import { useState, useEffect } from 'react';
import Styled from 'styled-components';

// We should try to get rid of this.

const OldColors = Styled.span`
  --neko-black-rgb: 0, 0, 0;
  --neko-blue-rgb: 0, 124, 186;
  --neko-blue-disabled: #459ad2;
  --neko-deep-blue: #134575;
  --neko-deep-blue-disabled: #446687;
  --neko-finder-border: #DEDEDE;
  --neko-light-blue: #EBF3FF;
  --neko-light-blue2: #d1e3f2;
  --neko-medium-blue: 200deg 45% 71%;
  --neko-light-gray: #cacaca;
  --neko-light-purple: #D8B1FF;
  --neko-gray: #E8E8E8;
  --neko-green: #0EA480;
  --neko-disabled-form: #828282;
  --neko-orange: #daa827;
  --neko-overlay: 16, 16, 16, 0.92;
  --neko-red: #ba4300;
  --neko-red-highlight: #de5307;
  --neko-header: #007cba;
  --neko-pro-gray: #7F8EA0;
  --neko-progress: #8414a8;
  --neko-purple: #956DBE;
  --neko-table-gray: #FAFAFA;
  --neko-yellow-rgb: 224, 156, 54;
  --neko-white-rgb: 255, 255, 255;
  --neko-lighten-blue: #1892d6;
  --neko-lighten-light-blue: #f0f7ff;
  --neko-lighten-red: #d35b00;
  --neko-lighten-green: #2ab295;
  --neko-lighten-deep-blue: #235e8c;
  --neko-lighten-black: #1a1a1a;
  --neko-lighten-dark-gray: #b3b3b3;
`;  

// We should have the properly named colors here.
// They shouldn't be used anywhere in the UI, only by the themes.

const BasicColors = Styled.span`
  --neko-white: #ffffff;
  --neko-black: #000000;
  --neko-orange: hsl(36deg 73.28% 54.51%);
  --neko-yellow: hsl(44.43deg 77.41% 53.14%);
  --neko-yellow-60: hsl(44.43deg 77.41% 60%);
  --neko-dark-gray: #A0A0A0;
  --neko-blue-overlay: rgb(30 124 186 / 85%);
  --neko-blue: hsl(200deg 100% 36.47%);
  --neko-blue-10: hsl(200deg 97.35% 12.06%);
  --neko-blue-20: hsl(200deg 100% 22.35%);
  --neko-blue-50: hsl(200deg 61.04% 54.71%);
  --neko-blue-80: hsl(200deg 55.93% 88.43%);
  --neko-blue-90: hsl(200deg 100% 98.82%);
  --neko-blue-amstrad: hsl(223.2deg 79.34% 55.12%);
  --neko-gray-30: hsl(200deg 10.45% 26.27%);
  --neko-gray-90: hsl(200deg 25% 92%);
  --neko-gray-95: hsl(0deg 0% 93.73%);
  --neko-gray-98: hsl(0deg 0% 96.47%);
`;

const LightTheme = Styled.span`
  --root-background: var(--neko-gray-90);
  --root-color: var(--neko-gray-30);
  --root-color-link: var(--neko-blue);
  --root-color-disabled: var(--neko-dark-gray);
  
  --block-background-overlay: var(--neko-blue-overlay);
  --block-background: var(--neko-blue);
  --block-background-alternative: var(--neko-blue-20);

  --block-font-color: var(--neko-white);
  --block-font-color-disabled: hsl(0deg 0% 0% / 25%);
  --block-background-disabled: var(--neko-blue-50);
  
  --content-background: var(--neko-white);
  --content-background-alternate: var(--neko-gray-98);
  --content-font-color: var(--neko-gray-30);

  --content-bar-background: var(--neko-gray-95);
  
  --neko-input-background: var(--neko-blue-90);
  --neko-input-border: var(--neko-blue-80);
  --neko-input-color: var(--neko-black);

  --neko-item-selected-background: var(--neko-blue-10);
  --neko-item-selected-color: var(--neko-white);

  --neko-pro-background: var(--neko-yellow);
  --neko-pro-background-hover: var(--neko-yellow-60);
  --neko-pro-color: var(--neko-white);

  --neko-success: var(--neko-blue);
  --neko-control-primary: var(--neko-blue);
  --neko-control-gradient: linear-gradient( 135deg, white -280%, var(--neko-control-primary) 100% );
  
  font-size: 13px;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
  color: var(--root-color);

  a {
    color: var(--root-color-link);
  }
`;

const DarkTheme = Styled.span`
  --root-background: #344751;
  --root-color: var(--neko-white);
  --root-color-link: var(--neko-blue);
  --root-color-disabled: var(--neko-dark-gray);

  --block-background: hsl(200deg 53.81% 19.62%);
  --block-background-alternative: hsl(200deg 53.81% 19.62%);
  --block-font-color: var(--neko-white);
  --block-font-color-disabled: var(--neko-dark-gray);
  --block-background-disabled: hsl(200.57deg 46.67% 14.71%);

  --content-background: hsl(200.53deg 61.29% 12.16%);
  --content-background-alternate: hsl(200.53deg 56.31% 10.87%);
  --content-font-color: var(--neko-white);

  --content-bar-background: hsl(201.43deg 66.67% 8.24%);

  --neko-input-background: hsl(198.62deg 29.3% 36.65%);
  --neko-input-border: hsl(200.38deg 52.48% 19.8%);
  --neko-input-color: var(--neko-white);

  --neko-item-selected-background: var(--neko-green);
  --neko-item-selected-color: var(--neko-white);

  --neko-pro-background: var(--neko-green);
  --neko-pro-background-hover: var(--neko-lighten-green);
  --neko-pro-color: var(--neko-white);

  --neko-success: hsl(--neko-blue-amstrad);
  --neko-control-primary: var(--neko-white);
  --neko-control-primary-gradient: linear-gradient( 135deg,
    var(--neko-control-primary),
    var(--neko-input-background) 240% );

  font-size: 13px;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
  color: var(--root-color);

  a {
    color: var(--root-color-link);
  }
`;

const useNekoColors = ({ theme = 'light' } = {}) => {
  const [currentTheme, setCurrentTheme] = useState('light');
  const toggleTheme = () => {
    setCurrentTheme(currentTheme === 'light' ? 'dark' : 'light');
  };
  useEffect(() => {
    if (theme) {
      setCurrentTheme(theme);
    }
  }, [theme]);
  const colors = {
    orange: '#daa827',
    green: '#0EA480',
    red: '#ba4300',
    purple: '#956DBE',
  };
  return { currentTheme, toggleTheme, colors, ThemeComponent: currentTheme === 'dark' ? DarkTheme : LightTheme };
};

const NekoUI = ({ theme, children }) => {
  const { ThemeComponent } = useNekoColors({ theme });

  return (<>
    <OldColors>
      <BasicColors>
        <ThemeComponent>
          {children}
        </ThemeComponent>
      </BasicColors>
    </OldColors>
  </>);
};

export default NekoUI;

export { useNekoColors };
